module.exports = [{
      plugin: require('/home/circleci/project/node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["UA-30709309-3"],"pluginConfig":{"head":false,"respectDNT":false,"exclude":["/preview/**","/do-not-track/me/too/"]}},
    },{
      plugin: require('/home/circleci/project/node_modules/gatsby-plugin-sentry/gatsby-browser.js'),
      options: {"plugins":[],"dsn":"https://bba3ac2fce53493aa80d5ca486fa635e@sentry.io/1351931","config":{"environment":"prod"}},
    }]
